import { render } from "./Insumos.vue?vue&type=template&id=7b71561a&scoped=true"
import script from "./Insumos.vue?vue&type=script&lang=js"
export * from "./Insumos.vue?vue&type=script&lang=js"

import "./Insumos.vue?vue&type=style&index=0&id=7b71561a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b71561a"]])

export default __exports__